import {
  createRouter,
  createWebHistory,
  RouteLocationNormalizedGeneric, Router, RouteRecordRaw,
  RouterOptions
} from "vue-router";
import { getCurrentUser } from "vuefire"; 
import AccessCheck from "@/components/AccessCheck.vue"
import SignIn from "@/components/Auth/SignIn.vue"
import AuthCallback from "@/components/Auth/AuthCallback.vue"
import SignOut from "@/components/Auth/SignOut.vue";
import NotFound from "@/components/Error/NotFound.vue";
import {ArticleEndpoint} from "@/enums.ts";
import ViewArticle from "./components/ViewArticle.vue";

function getQueryParamCaseInsensitive(query: RouteLocationNormalizedGeneric["query"], key: string) {
  const match = Object.keys(query).find(k => k.toLowerCase() === key.toLowerCase());
  return match ? query[match] : undefined;
}
function createUiRouter(routes: RouterOptions["routes"]): Router {

  const router = createRouter({
    history: createWebHistory(),
    routes
  });

  router.beforeEach(async (to) => {
    const currentUser =await getCurrentUser();
    // https://vuefire.vuejs.org/guide/auth.html#Wait-for-the-user-to-be-loaded
    // Wait for initialisation, if not initialised user will be `undefined`
    // await until(user).not.toBeUndefined();
    // const currentUser = user.value;

    if (to.meta.requiresAuth && !currentUser) {
    return {
      name: "signin",
      query: {
        redirect: to.fullPath
      }
    }
  }
  });
  return router
}

function createRoutes(config: { ENABLE_ARTICLE_VIEWER: boolean }): RouterOptions["routes"] {
  const routes: RouteRecordRaw[] = [
    {
      path: "/signin",
      name: "signin",
      component: SignIn,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/signout",
      name: "signout",
      component: SignOut,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/auth",
      name: "auth",
      component: AuthCallback,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/access-check",
      name: "access-check",
      props: route => ({
        mmoId: getQueryParamCaseInsensitive(route.query, "mmoId"),
        articleIds: getQueryParamCaseInsensitive(route.query, "articleIds"),
      redirectUrl: getQueryParamCaseInsensitive(route.query, "redirectUrl")
      }),
      component: AccessCheck,
      meta: {
        requiresAuth: true
      }
    }
  ];
  if (config.ENABLE_ARTICLE_VIEWER) {
    routes.push({
      path: "/articles/:id",
      name: "article",
      props: (route: RouteLocationNormalizedGeneric) => ({
        ids: route.params.id,
        branding: getQueryParamCaseInsensitive(route.query, "branding"),
        mmoId: getQueryParamCaseInsensitive(route.query, "mmoId"),
        P1: getQueryParamCaseInsensitive(route.query, "P1"),
        P2: getQueryParamCaseInsensitive(route.query, "P2"),
        P3: getQueryParamCaseInsensitive(route.query, "P3"),
        P4: getQueryParamCaseInsensitive(route.query, "P4"),
        P5: getQueryParamCaseInsensitive(route.query, "P5"),
        endpoint: ArticleEndpoint.SINGLE_ARTICLE,
      }),
      component: ViewArticle,
      meta: {
        requiresAuth: true,
      }
    })
    routes.push({
      path: "/articles",
      name: "articles",
      props: route => ({
        ids: getQueryParamCaseInsensitive(route.query, "ids"),
        branding: getQueryParamCaseInsensitive(route.query, "branding"),
        mmoId: getQueryParamCaseInsensitive(route.query, "mmoId"),
        P1: getQueryParamCaseInsensitive(route.query, "P1"),
        P2: getQueryParamCaseInsensitive(route.query, "P2"),
        P3: getQueryParamCaseInsensitive(route.query, "P3"),
        P4: getQueryParamCaseInsensitive(route.query, "P4"),
        P5: getQueryParamCaseInsensitive(route.query, "P5"),
        endpoint: ArticleEndpoint.MULTIPLE_ARTICLES,
      }),
      component: ViewArticle,
      meta: {
        requiresAuth: true,
      }
    })
  }

  routes.push({
      path: "/:catchAll(.*)",
      name: "fallback",
      component: NotFound,
      meta: {
        requiresAuth: false
      }
  });

  return routes
}

export {
  createRoutes,
  createUiRouter
}
